
import { api_host, api_auth} from '../../common/globals/constants';

export const getResponseWeighted = (objective,period, user, token) => 
    fetch(api_host+`/reporte/online/indicadores/ResponseHour/ResponseHourReporte2/?user=${user}&objetivoId=${objective}&t=${period}&hash=3276bd408a114308ab00c6133fe29fb2&token=${token}&key=${api_auth}`)
.then(response => response.json())

export const getResponseWeightedCustom = (objective,period, user, token, begin,final) => 
    fetch(api_host+`/reporte/online/indicadores/ResponseHour/ResponseHourReporte2/?user=${user}&objetivoId=${objective}&t=${period}&begin=${begin}&final=${final}&hash=3276bd408a114308ab00c6133fe29fb2&token=${token}&key=${api_auth}`)
.then(response => response.json())

